export default __webpack_public_path__ + "static/media/cover-landng-page.009bfdb0.png";